/**
 * RTWO Consensus Runtime Foundation — Configuration
 * RTWO v2.5 | Module ID: RTWO-CONR-001
 */

export function isConsensusRuntimeEnabled(): boolean {
  const flag = process.env.RTWO_CONSENSUS_RUNTIME_ENABLED?.trim().toLowerCase();
  if (flag === 'false') {
    return false;
  }
  return true;
}

export function isConsensusRuntimeBackendEnabled(): boolean {
  const flag = process.env.RTWO_CONSENSUS_RUNTIME_BACKEND_ENABLED?.trim().toLowerCase();
  return flag === 'true';
}
